import { reactive } from 'vue';

const state = reactive({
  toasts: [],
  seq: 1,
});

export function useToast() {
  function push({ title = '', message = '', variant = 'info', duration = 3500 } = {}) {
    const id = state.seq++;
    state.toasts.push({ id, title, message, variant });
    if (duration > 0) {
      setTimeout(() => remove(id), duration);
    }
    return id;
  }
  function remove(id) {
    const idx = state.toasts.findIndex(t => t.id === id);
    if (idx >= 0) state.toasts.splice(idx, 1);
  }
  return {
    toasts: state.toasts,
    push,
    remove,
    success(msg, title = 'Erfolg') { return push({ title, message: msg, variant: 'success' }); },
    info(msg, title = 'Hinweis') { return push({ title, message: msg, variant: 'info' }); },
    warn(msg, title = 'Achtung') { return push({ title, message: msg, variant: 'warn' }); },
    error(msg, title = 'Fehler') { return push({ title, message: msg, variant: 'error', duration: 5000 }); },
  };
}
